export default __webpack_public_path__ + "static/media/skillGames.ff859800.png";